import { useState, useEffect } from 'react'
import { supabase } from '@/lib/supabase'
import type { Contact } from '@/types'
import { DUMMY_CONTACTS } from '@/lib/dummyData'

export function useContacts(limit?: number) {
  const [contacts, setContacts] = useState<Contact[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let q = supabase.from('contacts').select('*').order('name')
    if (limit) q = q.limit(limit)
    q.then(({ data, error }) => {
      const rows = !error && data && data.length > 0 ? data : DUMMY_CONTACTS
      setContacts(limit ? rows.slice(0, limit) : rows)
      setLoading(false)
    })
  }, [limit])

  return { contacts, loading }
}

export function useContact(id: string) {
  const [contact, setContact] = useState<Contact | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!id) return
    supabase.from('contacts').select('*').eq('id', id).single().then(({ data }) => {
      setContact(data)
      setLoading(false)
    })
  }, [id])

  return { contact, loading }
}
